import React from 'react';

export const isSpecialClick = (event: React.MouseEvent): boolean => event.button === 1;
